var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ClippingPreviewMeta p-a-m border-b-grey-light"},[_c('div',{staticClass:"is-uppercase tracking-wider"},[_vm._v(" "+_vm._s(_vm.title)+": ")]),_c('div',{staticClass:"has-text-weight-bold"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }